import script from "./PayrollReports.vue?vue&type=script&setup=true&lang=js"
export * from "./PayrollReports.vue?vue&type=script&setup=true&lang=js"

import "./PayrollReports.vue?vue&type=style&index=0&id=7d5fbada&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d5fbada"]])

export default __exports__